<template>
  <div id="audienceCreate">
    <!-- Button trigger modal -->
    <button type="button" class="btn btn-primary create-button" data-toggle="modal" data-target="#exampleModal">
      Create New Audience
    </button>

    <!-- Modal -->
    <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Create new audience</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <audience-form></audience-form>
          </div>
          <div class="modal-footer pt-3" style="border-top:1px solid rgba(0,0,0,0.1)">
            <button id="close" type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary" @click="createAudience">Create audience</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AudienceForm from './AudienceForm'

export default {
  components: {
    AudienceForm
  },
  methods: {
    createAudience() {
      this.$emit('createAudience')
    }
  }
}
</script>

<style scoped>
  #audienceCreate {
    color: #000 !important;
  }
</style>